<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
  <div class="bg-white dark:bg-slate-900 w-full max-w-5xl rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden max-h-[92vh] flex flex-col">
    <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between shrink-0">
      <div>
        <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100">{{ isEdit ? 'แก้ไข Main Rate' : 'เพิ่ม Main Rate' }}</h3>
        <p class="text-xs text-slate-400 mt-0.5">เลือก Sub Rate / Penalty แล้วดูรายละเอียดที่ join มาด้านล่างช่องเลือก</p>
      </div>
      <button type="button" (click)="onClose()" class="w-9 h-9 rounded-xl text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer border-none bg-transparent"><span class="material-icons text-[20px]">close</span></button>
    </div>

    <div class="p-6 space-y-5 overflow-y-auto" *ngIf="!isLoading(); else loadingTpl">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">Main Rate ID <span class="text-rose-500">*</span></label>
          <input type="text" [(ngModel)]="formData.mainRateId" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <div class="space-y-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">ชื่อ <span class="text-rose-500">*</span></label>
          <input type="text" [(ngModel)]="formData.name" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
      </div>

      <!-- Customer -->
      <section class="space-y-3">
        <h4 class="text-xs font-black uppercase tracking-widest text-sky-600 dark:text-sky-400">Customer Sub Rate</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Customer Car</label>
            <select [(ngModel)]="formData.rateCustomerCarId" (ngModelChange)="onSubRateChange('rateCustomerCar', 'rateCustomerCarId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateCustomerCar }"></ng-container>
          </div>
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Customer Bike</label>
            <select [(ngModel)]="formData.rateCustomerBikeId" (ngModelChange)="onSubRateChange('rateCustomerBike', 'rateCustomerBikeId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateCustomerBike }"></ng-container>
          </div>
        </div>
      </section>

      <!-- Tenant -->
      <section class="space-y-3">
        <h4 class="text-xs font-black uppercase tracking-widest text-violet-600 dark:text-violet-400">Tenant Sub Rate</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Tenant Car</label>
            <select [(ngModel)]="formData.rateTenantCarId" (ngModelChange)="onSubRateChange('rateTenantCar', 'rateTenantCarId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateTenantCar }"></ng-container>
          </div>
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Tenant Bike</label>
            <select [(ngModel)]="formData.rateTenantBikeId" (ngModelChange)="onSubRateChange('rateTenantBike', 'rateTenantBikeId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateTenantBike }"></ng-container>
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Min Tenant Allow Car (นาที)</label>
            <input type="number" [(ngModel)]="formData.minTenantAllowCar" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Min Tenant Allow Bike (นาที)</label>
            <input type="number" [(ngModel)]="formData.minTenantAllowBike" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
      </section>

      <!-- Holiday -->
      <section class="space-y-3">
        <h4 class="text-xs font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">Holiday Sub Rate</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Holiday Car</label>
            <select [(ngModel)]="formData.rateHolidayCarId" (ngModelChange)="onSubRateChange('rateHolidayCar', 'rateHolidayCarId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateHolidayCar }"></ng-container>
          </div>
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Holiday Bike</label>
            <select [(ngModel)]="formData.rateHolidayBikeId" (ngModelChange)="onSubRateChange('rateHolidayBike', 'rateHolidayBikeId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of subRateOptions" [value]="o.rateId">{{ o.rateId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="subDetailCard; context: { $implicit: formData.rateHolidayBike }"></ng-container>
          </div>
        </div>
      </section>

      <!-- Penalty -->
      <section class="space-y-3">
        <h4 class="text-xs font-black uppercase tracking-widest text-rose-600 dark:text-rose-400">Penalty Rate</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Penalty Car</label>
            <select [(ngModel)]="formData.penaltyCarId" (ngModelChange)="onPenaltyChange('penaltyCar', 'penaltyCarId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of penaltyRateOptions" [value]="o.penaltyId">{{ o.penaltyId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="penaltyDetailCard; context: { $implicit: formData.penaltyCar }"></ng-container>
          </div>
          <div class="space-y-2">
            <label class="text-xs font-bold text-slate-500">Penalty Bike</label>
            <select [(ngModel)]="formData.penaltyBikeId" (ngModelChange)="onPenaltyChange('penaltyBike', 'penaltyBikeId')"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
              <option value="">— ไม่ระบุ —</option>
              <option *ngFor="let o of penaltyRateOptions" [value]="o.penaltyId">{{ o.penaltyId }} — {{ o.name }}</option>
            </select>
            <ng-container *ngTemplateOutlet="penaltyDetailCard; context: { $implicit: formData.penaltyBike }"></ng-container>
          </div>
        </div>
      </section>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">Comment (TH)</label>
          <textarea [(ngModel)]="formData.commentTh" rows="2" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
        </div>
        <div class="space-y-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">Comment (EN)</label>
          <textarea [(ngModel)]="formData.commentEn" rows="2" class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
        </div>
      </div>
    </div>

    <ng-template #loadingTpl><div class="p-10 text-center text-slate-400 text-sm">กำลังโหลด...</div></ng-template>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3 shrink-0">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 shrink-0">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 flex-1 justify-end">
        <button type="button" (click)="onClose()" [disabled]="isSaving()" class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 cursor-pointer bg-transparent disabled:opacity-50">ยกเลิก</button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()" class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">{{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}</button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingMainRate"
  [entityId]="itemId"
  title="ประวัติอัตราหลัก"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<!-- Sub Rate detail card -->
<ng-template #subDetailCard let-d>
  <div *ngIf="d" class="rounded-xl border border-slate-200/80 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/50 p-3 text-[11px] leading-relaxed">
    <div class="flex items-center gap-2 mb-2">
      <span class="px-2 py-0.5 rounded-md bg-sky-100 dark:bg-sky-900/40 text-sky-700 dark:text-sky-300 font-mono font-bold">{{ d.rateId }}</span>
      <span class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ d.name || '—' }}</span>
      <span *ngIf="d.rateType" class="ml-auto shrink-0 px-2 py-0.5 rounded-full bg-slate-200/80 dark:bg-slate-700 text-slate-600 dark:text-slate-300 font-bold">{{ d.rateType }}</span>
    </div>
    <div class="grid grid-cols-2 gap-x-3 gap-y-1 text-slate-600 dark:text-slate-300">
      <div><span class="text-slate-400">Free YN</span> {{ d.subFreeTimeYn || '—' }}</div>
      <div><span class="text-slate-400">Free (นาที)</span> {{ d.minFreeTime ?? '—' }}</div>
      <div><span class="text-slate-400">Round</span> {{ d.minRound ?? '—' }}</div>
      <div><span class="text-slate-400">Period free</span> {{ d.timePeriodFree || '—' }}</div>
      <div><span class="text-slate-400">฿/ชม.</span> <b class="text-amber-600">{{ d.pricePerHour ?? '—' }}</b></div>
      <div><span class="text-slate-400">Flat ชม./ราคา</span> {{ d.hourOverFlat ?? '—' }} / {{ d.priceFlat ?? '—' }}</div>
      <div><span class="text-slate-400">Cut time</span> {{ d.cutTime || '—' }}</div>
      <div><span class="text-slate-400">Format</span> {{ d.format || '—' }}</div>
      <div class="col-span-2"><span class="text-slate-400">Service fmt</span> {{ d.serviceChargeFormat || '—' }}</div>
      <div class="col-span-2" *ngIf="d.comment"><span class="text-slate-400">Comment</span> {{ d.comment }}</div>
    </div>
  </div>
</ng-template>

<!-- Penalty detail card -->
<ng-template #penaltyDetailCard let-d>
  <div *ngIf="d" class="rounded-xl border border-rose-200/70 dark:border-rose-900/40 bg-rose-50/50 dark:bg-rose-950/20 p-3 text-[11px] leading-relaxed">
    <div class="flex items-center gap-2 mb-2">
      <span class="px-2 py-0.5 rounded-md bg-rose-100 dark:bg-rose-900/40 text-rose-700 dark:text-rose-300 font-mono font-bold">{{ d.penaltyId }}</span>
      <span class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ d.name || '—' }}</span>
    </div>
    <div class="grid grid-cols-2 gap-x-3 gap-y-1 text-slate-600 dark:text-slate-300">
      <div><span class="text-slate-400">Over time</span> {{ d.overTime || '—' }}</div>
      <div><span class="text-slate-400">Fine</span> <b class="text-rose-600">{{ d.finePrice != null ? (d.finePrice | number) : '—' }}</b></div>
    </div>
  </div>
</ng-template>
